import React from "react";
import { Form } from "antd";
import { Controller } from "react-hook-form";
// import { InfoIconOutlined } from "../CustomIcons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export interface InputPhoneProps {
  fieldname: string;
  isRequired?: boolean;
  label?: string;
  validate?: any;
  validMessage?: string | any;
  className?: string;
  control: any;
  initValue?: any;
  rules?: any;
  iProps?: any;
  prefix?: any;
  disabled?: boolean;
  tooltipTitle?: string | any;
  optionalLabel?: string;
  hintMessage?: string;
}

const InputPhone: React.FunctionComponent<InputPhoneProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  prefix,
  disabled,
  tooltipTitle,
  optionalLabel,
  hintMessage,
}: InputPhoneProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      label={label}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          // icon: (
          //   <InfoIconOutlined style={{ color: "#505560", fontSize: "14px" }} />
          // ),
        }
      }
    >
      <Controller
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ""}
        rules={rules}
        render={({ field: { onChange, value, onBlur } }) => (
          <>
            <PhoneInput
              disabled={disabled && disabled}
              country={"us"}
              value={value}
              onChange={(e) => {
                onChange(e);
              }}
            />
            {optionalLabel && (
              <div className="optional-label">{optionalLabel}</div>
            )}
            {hintMessage && <div className="hint-label">{hintMessage}</div>}
          </>
        )}
      />
    </Form.Item>
  );
};

export default InputPhone;
